import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useParams, useNavigate, Link } from 'react-router-dom';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

export default function Update() { 
    const [ appointment, setAppointment ] = useState([]);
    const [ users, setUsers ] = useState([]);
    const { id } = useParams();
    const idRef = useRef();
    const userRef = useRef();
    const departmentRef = useRef();
    const doctorRef = useRef();
    const descriptionRef = useRef();
    const navigate = useNavigate();
    const [ from, onFromChange ] = useState(new Date());
    const [ to, onToChange ] = useState(new Date());


    const GetUsers = useCallback(() => { 
        axios.get('http://localhost:5000/Users/AllUsers')
            .then((response) => { 
                setUsers(response.data);
            })
            .catch((error) => { 
                console.log(error);
            })
    }, [users]);


    const GetAppointment = useCallback(() => { 
        axios.post('http://localhost:5000/Appointments/GetAppointment', { id: id})
            .then((response) => { 
                setAppointment(response.data[0]);
            })
            .catch((error) => { 
                console.log(error);
            })
    })

    useEffect(() => { 
        GetUsers();
        GetAppointment();
    });

    useEffect(() => { 
        GetUsers();
        GetAppointment();
    }, [users, appointment]);



    return(
        <React.Fragment>
            <main>
            <h1>Update Appointment</h1>
            <span>
            <Link to="/Admin/Appointments" className="btn btn-secondary">Back</Link>
            </span>
                <section>
                    <article>
                        <Formik
                            enableReinitialize={true}
                            initialValues={{ id: '', user: '', department: '', doctor: '', description: '', from: '', to: '' }}
                            onSubmit={(values, { setSubmitting }) => { 
                            
                                axios.post('http://localhost:5000/Appointments/UpdateAppointment', { id: idRef.current.value, user: userRef.current.value, department: departmentRef.current.value, doctor: doctorRef.current.value, description: descriptionRef.current.value, from: from, to: to })
                                    .then((response) => { 
                                        if (response.status === 200) {
                                            navigate('/Admin/Appointments');
                                        }
                                    })
                                    .catch((error) => { 
                                        console.log(error);
                                    })
                            }}
                        >
                            {({
                                values, 
                                errors, 
                                touched, 
                                handleChange, 
                                handleBlur, 
                                handleSubmit, 
                                isSubmitting
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="formContainer">
                                        <label htmlFor="id">ID:</label>
                                        <input type="text" value={appointment._id} ref={idRef} disabled />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="user">User:</label>
                                        <select id="user" name="user" onChange={handleChange} onBlur={handleBlur} value={values.user} ref={userRef}>
                                            {
                                                [...Array((users.length))].map((e, i) => 
                                                    <option key={i} value={users[i]._id}>{users[i].email}</option>
                                                )
                                            }
                                        </select>
                                        
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="department">Department:</label>
                                        <select name="department" onChange={handleChange} onBlur={handleBlur} value={values.department} ref={departmentRef}>
                                            <option value="Diagnostic Imaging">Diagnostic Imaging</option>
                                            <option value="Ear, Nose and Throat">Ear, Nose and Throat</option>
                                            <option value="General Surgery">General Surgery</option>
                                            <option value="Haematology">Haematology</option>
                                            <option value="Neurology">Neurology</option>
                                        </select>
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="doctor">Doctor:</label>
                                        <select name="doctor" onChange={handleChange} onBlur={handleBlur} value={values.doctor} ref={doctorRef}>
                                            <option value="Dr Lewis Zimmerman">Doctor Lewis Zimmerman</option>
                                            <option value="Doctor Leonard McCoy">Doctor Leonard MacCoy</option>
                                            <option value="Doctor Beverley Crusher">Doctor Beverley Crusher</option>
                                            <option value="Doctor Julian Bashir">Doctor Julian Bashir</option>
                                        </select>
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="description">Description</label>
                                        <textarea name="description" onChange={handleChange} onBlur={handleBlur} value={values.description} ref={descriptionRef}></textarea>
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="from">From:</label>
                                        <DateTimePicker name="from" defaultValue={appointment.from} value={from} onChange={onFromChange} className="Calendar" />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="to">To:</label>
                                        <DateTimePicker name="to" defaultValue={appointment.to} value={to} onChange={onToChange} />
                                    </div>
                                    <button type="submit">Submit</button>
                                </form>
                            )}
                        </Formik>
                    </article>
                </section>
            </main>

            

        </React.Fragment>
    )
}